import { useState, useEffect } from "react";
import {
  getDocs,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  limit,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { getSubCollection } from "../utils/getSubCollection";
import RemisionForm from "../components/RemisionForm";
import TablaRemisiones from "../components/TablaRemisiones";
import PreviaRemision from "../components/PreviaRemision";

function Remisiones({ mostrarBotonNuevo }) {
  const { user, teamOwnerId } = useAuth();
  const ownerUid = teamOwnerId || user.uid;
  const [remisiones, setRemisiones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [numeroRemision, setNumeroRemision] = useState(1);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarPrevia, setMostrarPrevia] = useState(false);
  const [remisionSeleccionada, setRemisionSeleccionada] = useState(null);

  useEffect(() => {
    // 1) Cargar clientes
    const clientesRef = getSubCollection(ownerUid, "clientes");
    getDocs(clientesRef).then((snap) =>
      setClientes(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );

    // 2) Calcular siguiente número de remisión
    const remisionesRef = getSubCollection(ownerUid, "remisiones");
    const q = query(remisionesRef, orderBy("numeroRemision", "desc"), limit(1));
    getDocs(q).then((snap) => {
      if (!snap.empty) {
        const maxNum = snap.docs[0].data().numeroRemision || 0;
        setNumeroRemision(maxNum + 1);
      }
    });

    // 3) Suscripción en tiempo real a remisiones
    const unsubscribe = onSnapshot(remisionesRef, (snap) => {
      setRemisiones(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsubscribe();
  }, [ownerUid]);

  const activarFormulario = () => {
    setRemisionSeleccionada(null);
    setMostrarFormulario(true);
  };

  const guardarRemision = async (remData, modoEdicion, remId) => {
    const remisionesRef = getSubCollection(ownerUid, "remisiones");
    if (modoEdicion && remId) {
      // — Actualizar existente —
      const ref = doc(remisionesRef, remId);
      await updateDoc(ref, remData);
    } else {
      // — Crear nuevo —
      await addDoc(remisionesRef, {
        ...remData,
        ownerId: ownerUid,
        numeroRemision,
        createdAt: serverTimestamp(),
        estado: "Pendiente",
      });
      setNumeroRemision((n) => n + 1);
    }
    setMostrarFormulario(false);
  };

  const verPrevia = (r) => {
    setRemisionSeleccionada(r);
    setMostrarPrevia(true);
  };

  return (
    <div>
      {!mostrarFormulario && mostrarBotonNuevo && (
        <button className="action-button2" onClick={activarFormulario}>
          + Nuevo
        </button>
      )}

      {mostrarFormulario ? (
        <RemisionForm
          clientes={clientes}
          remision={remisionSeleccionada}
          modoEdicion={Boolean(remisionSeleccionada)}
          guardarRemision={guardarRemision}
          closeModal={() => setMostrarFormulario(false)}
          numeroRemision={numeroRemision}
        />
      ) : mostrarPrevia ? (
        <PreviaRemision
          remision={remisionSeleccionada}
          clientes={clientes}
          numeroRemision={remisionSeleccionada.numeroRemision}
          cerrarPrevia={() => setMostrarPrevia(false)}
        />
      ) : (
        <TablaRemisiones
          remisiones={remisiones}
          clientes={clientes}
          verPrevia={verPrevia}
          guardarRemision={guardarRemision}
          setRemisiones={setRemisiones}
          numeroRemision={numeroRemision}
        />
      )}
    </div>
  );
}

export default Remisiones;
